import './index.sass'
import "../../main.css"

import StoreContext from "../../store/RootStore";
import { useEffect, useRef, useState } from "react";
import { observer } from "mobx-react";
import LoginHandler from "../../functions/login";

function AvatarPage() {
  const { AccountStore } = StoreContext();

  const [count, setCount] = useState(0);
  const [cost, setCost] = useState("0.0000 DOVX");

  // Instance stable de LoginHandler pour éviter les re-créations à chaque rendu
  const loginHandlerRef = useRef(null);
  if (loginHandlerRef.current === null) {
    loginHandlerRef.current = new LoginHandler();
  }
  const loginHandler = loginHandlerRef.current;

  useEffect(() => {
    // RAS pour le moment, on garde le hook si tu veux réagir plus tard à accountAddress
  }, [AccountStore.accountAddress]);

  async function choose(id) {
    await loginHandler.sendTransaction(
      [
        {
          account: loginHandler.Gamecontract,
          name: "setavatar",
          authorization: [
            {
              actor: AccountStore.accountAddress,
              permission: AccountStore.getUserData().requestPermission,
            },
          ],
          data: {
            player: AccountStore.accountAddress,
            avatar_id: id,
          },
        },
      ],
      AccountStore.getUserData()[0],
      "Transaction successfull"
    );
    setTimeout(() => {
      loginHandler.getUserBalancetkn();
      loginHandler.getUserBalancewax();
    }, 1000);
  }

  const handleAvType = (asset) => {
    setCount(asset.id);
    setCost(asset.cost);
  };

  return (
    <div className="parent verticalCenter">
      <div className="avatar">
        <h1>SELECT YOUR AVATAR ICON</h1>
        <h2>
          Cost:{" "}
          <span>
            {AccountStore.avatarData.length > 0
              ? AccountStore.avatarData[0].cost
              : cost}
          </span>
        </h2>

        {AccountStore.avatarData.map((asset, index) => {
          const isChecked =
            AccountStore.getAvatarIndex().id === asset.id && count === 0;

          return (
            <label key={index}>
              {isChecked ? (
                <input type="radio" name="avatarIcon" value={asset.id} checked readOnly />
              ) : (
                <input type="radio" name="avatarIcon" value={asset.id} readOnly />
              )}
              <img
                src={`https://dov-gw.mypinata.cloud/ipfs/${asset.ipfs}`}
                alt=""
                onClick={() => {
                  handleAvType(asset);
                }}
              />
              {asset.id === 4 || asset.id === 7 || asset.id === 11 ? (
                <div className="clearfix" />
              ) : (
                <></>
              )}
            </label>
          );
        })}

        <div className="btnBlue">
          <button
            onClick={() => {
              choose(count);
            }}
            disabled={count === 0}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}

export default observer(AvatarPage);
